import React from "react";
import { stepsData } from "../../assets/constants/homePageConstants";
const WorkSection = () => {
  

  return (
    <section className="work-section padding-tb">
      <div className="container">
        <div className="section-header">
          <h4 className="theme-color">كيف وجدت خدماتنا ؟</h4>
          <h2> أنت على بعد أربع خطوات من ايجادك لشريك حياتك</h2>
        </div>
        <div className="section-wrapper">
          <div className="row justify-content-center g-5">
            {stepsData.map((step, index) => (
              <div key={index} className="col-lg-3 col-sm-6 col-12 px-4">
                <div className="lab-item work-item">
                  <div className="lab-inner text-center">
                    <div className="lab-thumb">
                      <div className="thumb-inner">
                        <img src={step.image} alt="work-img" />
                        <div className="step">
                          <span>{step.id}</span>
                        </div>
                      </div>
                    </div>
                    <div className="lab-content">
                      <h4>{step.title}</h4>
                      <p>{step.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkSection;
